import { useEffect } from "react";
import Lenis from "lenis";

/** Momentum-smooth scrolling for the whole page. Auto-detaches on unmount. */
export default function useSmoothScroll(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    const lenis = new Lenis({
      duration: 1.4,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.4,
    });
    let rafId = 0;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, [enabled]);
}
